import { useTranslations } from 'next-intl';

import HeartIcon from '@/fo/icons/base/icons/hearts.svg';

import { styles } from './UiReviewRecommendPercent.styles';

export interface UiReviewRecommendPercentProps {
  percent: number | string;
}

export function UiReviewRecommendPercent({
  percent
}: UiReviewRecommendPercentProps) {
  const t = useTranslations();
  const slots = styles();

  return (
    <div className={slots.base()}>
      <HeartIcon className={slots.icon()} />
      <span className={slots.text()}>
        {t('review.labels.recommendPercent', { percent })}
      </span>
    </div>
  );
}
